import axios from "axios";
import { toast } from "react-toastify";

const ParticipantService = {
  findParticipantsByType: async (type) => {
    const token = localStorage.getItem("user-token");

    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_DELEND_API}/participants?type=${type}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return axios(config)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        toast.error(error.response.data.errorDescription);
      });
  },
};

export default ParticipantService;